import './price.scss';
import $ from 'jquery';
import SharedWidgetPricingService, * as PriceUtils from '../../shared/PricingService/SharedWidgetPricingService'

const $priceContainer = $('.product-model-price-container .price-model');
const categoryId = $priceContainer.data('product-group-id');
const modelId = $priceContainer.data('price-model-id');
const isDontBuy = !!$priceContainer.data('is-dont-buy');
const modelName = $priceContainer.data('product-display-name');
const brandName = $priceContainer.data('brand-name');
const img = $priceContainer.data('img');
const overallScore = $priceContainer.data('overall-score');
const isRecommended = $priceContainer.data('is-recommended');
const isSubscriber = $priceContainer.data('is-subscriber');
const isBestBuy = $priceContainer.data('is-best-buy');
const overallScoreType = $priceContainer.data('overall-score-type');

const onPriceAndShopLoadListener = (event, type, data) => {
    const minPriceSelector = '.min-price';
    const basePrice = PriceUtils.getBasePrice('.price-model');
    const $elem = $('[data-price-model-id=\'' + data.modelId + '\']');

    if (type === 'loadData-model' && data) {
        $('#price-and-shop,#priceShopBtn').removeClass('hidden');

        const price = PriceUtils.definePriceRange(data);
        if (price.minPrice && !isDontBuy) {
            $($elem).find(minPriceSelector).html('$' + PriceUtils.formatPrice(price.minPrice));
            $($elem).find('.price-range').html(price.priceString);
        } else if (basePrice) {
            $($($elem).find(minPriceSelector)).html(basePrice);
        }
    } else if (type === 'loadData-error') {
        if (basePrice) {
            $($($elem).find(minPriceSelector)).html(basePrice);
        }
    }
};

export default function () {
    if (!categoryId || !modelId) return;

    $(window).on('cro.products.price-and-shop', onPriceAndShopLoadListener);

    SharedWidgetPricingService({
        modelSellerDataSelector: '#price-table',
        modelId,
        isSubscriber,
        model: {
            modelName,
            brandName,
            img,
            overallScore,
            isRecommended,
            isBestBuy,
            overallScoreType,
        }
    });
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/Price/index.js